import React, { useState, useEffect } from 'react';

const quotes = [
  {
    text: "La coscienza non è un algoritmo. Il microprocessore nasce dalla creatività umana, non dalla macchina.",
    author: "Federico Faggin",
    role: "Inventore del primo microprocessore Intel 4004, 1971",
    image: "https://customer-assets.emergentagent.com/job_28928934-11dd-4284-98b6-2ad0e3658a04/artifacts/udixlknn_image.png",
    imageCaption: "Intel 4004 — Il chip che ha cambiato il mondo. Nato dalla mente di un italiano.",
    color: "#FFD700",
    aicovo: "AI_COVO onora Faggin: la tecnologia nasce dall'intuizione umana. Noi la insegniamo.",
  },
  {
    text: "Stay Hungry. Stay Foolish.",
    author: "Steve Jobs",
    role: "Co-fondatore Apple, Stanford 2005",
    color: "#FFFFFF",
    aicovo: "AI_COVO è fame di sapere. Ogni alunno è un visionario che non lo sa ancora.",
  },
  {
    text: "Un computer su ogni scrivania e in ogni casa.",
    author: "Bill Gates",
    role: "La visione che ha cambiato il mondo, 1975",
    color: "#00BFFF",
    aicovo: "AI_COVO porta il digitale in ogni casa — non il computer, ma la competenza per usarlo.",
  },
  {
    text: "La missione di Google è organizzare le informazioni del mondo e renderle universalmente accessibili.",
    author: "Larry Page & Sergey Brin",
    role: "Fondatori Google, garage di Menlo Park, 1998",
    color: "#4285F4",
    aicovo: "AI_COVO rende il sapere digitale accessibile a chi è rimasto indietro. Stessa missione, scala locale.",
  },
];

const VisionaryQuote = () => {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * quotes.length));
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex(prev => (prev + 1) % quotes.length);
        setFade(true);
      }, 600);
    }, 12000);
    return () => clearInterval(interval);
  }, []);

  const q = quotes[index];

  return (
    <section data-testid="visionary-quote" className="py-16 border-t border-white/5">
      <div className={`max-w-4xl mx-auto px-6 transition-all duration-600 ${fade ? 'opacity-100' : 'opacity-0'}`}
        style={{ transition: 'opacity 0.6s ease' }}>
        
        {q.image && (
          <div className="flex justify-center mb-6">
            <div className="relative">
              <img src={q.image} alt={q.imageCaption || q.author} 
                className="h-32 md:h-40 w-auto object-contain rounded-lg border border-zinc-800"
                style={{ filter: 'contrast(1.1) brightness(0.95)' }} />
              <div className="absolute -bottom-2 -right-2 px-2 py-0.5 bg-[#00FF41] text-black font-mono text-[8px] font-bold">
                &lt;/AI_COVO&gt;
              </div>
            </div>
          </div>
        )}

        <blockquote className="text-center">
          <p className="text-2xl md:text-3xl font-black italic leading-tight mb-4"
            style={{ color: q.color, textShadow: `0 0 30px ${q.color}33` }}>
            "{q.text}"
          </p>
          <footer className="mb-4">
            <p className="font-mono text-sm font-bold" style={{ color: q.color }}>{q.author}</p>
            <p className="text-white text-xs font-mono font-bold">{q.role}</p>
          </footer>
          {q.imageCaption && (
            <p className="text-zinc-600 text-xs italic mb-3">{q.imageCaption}</p>
          )}
          <div className="inline-block bg-[#00FF41]/5 border border-[#00FF41]/20 px-4 py-2">
            <p className="text-[#00FF41] text-xs font-mono">{q.aicovo}</p>
          </div>
        </blockquote>

        {/* Dots indicator */}
        <div className="flex justify-center gap-2 mt-6">
          {quotes.map((_, i) => (
            <button key={i} onClick={() => { setFade(false); setTimeout(() => { setIndex(i); setFade(true); }, 300); }}
              className={`w-2 h-2 rounded-full transition-all ${i === index ? 'bg-[#00FF41] scale-125' : 'bg-zinc-700 hover:bg-zinc-500'}`}
              data-testid={`quote-dot-${i}`} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default VisionaryQuote;
